import { Card, Typography } from "antd";
import "./TechnologyCard.scss";

const { Title, Text } = Typography;

export default function TechnologyCard({ token }) {
  return (
    <Card
      className="aboutTechnology-card"
      hoverable
      style={{
        border: "none",
        backgroundColor: token?.Card?.colorBgCard,
        borderLeft: `4px solid ${token?.colorSecondaryLogo}`,
      }}>
      <div className="aboutTechnology-card__content">
        <Title
          level={3}
          style={{ color: token?.colorSecondaryLogo, margin: 0 }}>
          Built with Modern Technology
        </Title>
        <Text className="aboutTechnology-card__text">
          We leverage cutting-edge technologies to deliver a seamless
          experience. Our decentralized approach ensures data integrity and puts
          control where it belongs—in your hands.
        </Text>
        <Text className="aboutTechnology-card__text">
          From advanced search algorithms to real-time synchronization, every
          feature is designed with performance and reliability in mind.
        </Text>
      </div>
    </Card>
  );
}
